'use client';

import { usePathname } from 'next/navigation';
import { ReactElement } from 'react';
import { CLIENT_ORG_COMPONENTS } from '@provider-directory/app/lib/client-org-component';
import { useOrgContext } from '../org-context/org-context-provider';
import DefaultFooter from './default-footer.component';

const Footer = ({ className }: { className?: string }): ReactElement => {
  const { key, config } = useOrgContext();
  const pathname = usePathname();
  if (pathname.includes('appointment/request')) {
    return <></>;
  }

  const FooterContent = CLIENT_ORG_COMPONENTS[key]?.footerContent;

  return FooterContent ? (
    <FooterContent className={className} />
  ) : (
    <DefaultFooter config={config} className={className} />
  );
};

export default Footer;
